import { Routes } from '@angular/router';
import { PosmProjectListComponent } from './posm-project-list/posm-project-list.component';
import { CreatePosmProjectComponent } from './create-posm-project/create-posm-project.component';
import { PosmProjectDetailsComponent } from './posm-project-details/posm-project-details.component';
import { PosmSetupComponent } from './posm-setup/posm-setup.component';
import { PosmClientTrackingComponent } from './posm-client-tracking/posm-client-tracking.component';
import { PosmDeliveryScheduleListComponent } from './posm-delivery-schedules/posm-delivery-schedule-list.component';
import { PosmDeliveryScheduleDetailComponent } from './posm-delivery-schedules/posm-delivery-schedule-detail.component';
import { PosmDeliveryScheduleDetailComponent as PosmProjectDeliveryScheduleDetailComponent } from './posm-project-details/posm-delivery-schedule-detail/posm-delivery-schedule-detail.component';
import { PosmDeliveryScheduleFormComponent } from './posm-project-details/posm-delivery-schedule-detail/posm-delivery-schedule-form.component';
import { PermissionGuard } from '../security/permission.guard';
import { EnterpriseSubscriptionGuard } from '../security/enterprise-subscription.guard';
import { app_permissions } from '../security/app-permissions';

export const posmRoutes: Routes = [
    {
        path: 'posm/client-tracking/:token',
        component: PosmClientTrackingComponent
    },
    {
        path: 'posm',
        canActivateChild: [EnterpriseSubscriptionGuard],
        data: { enterpriseModules: ['POSM_PROJECT_TRACKING'], enterpriseFeatureLabel: 'POSM Execution Tracking' },
        children: [
            {
                path: 'setup',
                component: PosmSetupComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.posm.planning.manage }
            },
            {
                path: 'executions',
                component: PosmProjectListComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.posm.projects.view }
            },
            {
                path: 'executions/create',
                component: CreatePosmProjectComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.posm.projects.create }
            },
            {
                path: 'executions/:id/import-schedules',
                component: CreatePosmProjectComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.posm.projects.edit, importSchedules: true }
            },
            {
                path: 'executions/:id/edit',
                component: CreatePosmProjectComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.posm.projects.edit }
            },
            {
                path: 'executions/delivery-schedules',
                component: PosmDeliveryScheduleListComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.posm.projects.view }
            },
            {
                path: 'executions/delivery-schedules/:id',
                component: PosmDeliveryScheduleDetailComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.posm.projects.view }
            },
            {
                path: 'executions/:projectId/delivery-schedule/new',
                component: PosmDeliveryScheduleFormComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.posm.projects.create }
            },
            {
                path: 'executions/:projectId/delivery-schedule/:lineId/edit',
                component: PosmDeliveryScheduleFormComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.posm.projects.edit }
            },
            {
                path: 'executions/:projectId/delivery-schedule/:lineId',
                component: PosmProjectDeliveryScheduleDetailComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.posm.projects.view }
            },
            {
                path: 'executions/:id',
                component: PosmProjectDetailsComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.posm.projects.view }
            },
            {
                path: 'projects',
                redirectTo: 'executions',
                pathMatch: 'full'
            },
            {
                path: 'projects/create',
                redirectTo: 'executions/create',
                pathMatch: 'full'
            },
            {
                path: 'delivery-schedules',
                redirectTo: 'executions/delivery-schedules',
                pathMatch: 'full'
            },
            {
                path: 'delivery-schedules/:id',
                redirectTo: 'executions/delivery-schedules/:id',
                pathMatch: 'full'
            },
            {
                path: 'projects/:projectId/delivery-schedule/new',
                redirectTo: 'executions/:projectId/delivery-schedule/new',
                pathMatch: 'full'
            },
            {
                path: 'projects/:projectId/delivery-schedule/:lineId',
                redirectTo: 'executions/:projectId/delivery-schedule/:lineId',
                pathMatch: 'full'
            },
            {
                path: 'projects/:projectId/delivery-schedule/:lineId/edit',
                redirectTo: 'executions/:projectId/delivery-schedule/:lineId/edit',
                pathMatch: 'full'
            },
            {
                path: 'projects/:id',
                redirectTo: 'executions/:id',
                pathMatch: 'full'
            }
        ]
    }
];
